<template>
  <b-card>
    <h3 class="font-semibold text-[#333] text-[20px] pb-[16px] mb-[16px]">
      Upgrade Status
    </h3>
    <filter-component
      ref="filterComponent"
      @filter-change="handleFilterChange"
    />
    <table-component
      ref="tableComponent"
      :filter="filter"
    />
  </b-card>
</template>

<script>
import FilterComponent from './Filter.vue'
import TableComponent from './Table.vue'

export default {
  components: {
    FilterComponent,
    TableComponent,
  },
  data() {
    return {
      filter: {
        keyword: '',
        category: [],
      },
    }
  },
  mounted() {
    this.$nextTick(() => this.fetchFromCurrentFilter())
  },
  methods: {
    /**
     * Muat data tabel sesuai filter dari komponen filter
     */
    fetchFromCurrentFilter() {
      const { filterComponent, tableComponent } = this.$refs
      if (!filterComponent || !tableComponent) return
      this.handleFilterChange(filterComponent.emitFilterChange())
    },
    /**
     * Refresh data tabel dengan filter baru
     * @param {{ keyword: string, category: string[] }} filter
     */
    handleFilterChange(filter) {
      this.$refs.tableComponent.refreshData({
        category: filter.category,
        keyword: filter.keyword,
      })
    },
  },
}
</script>
